import React from 'react';
import { cssMap } from '@compiled/react';
import { graphql } from 'react-relay';

import { token } from '@atlaskit/tokens';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import type {
	SmartSpaceOverviewSummaryQuery$data,
	SmartSpaceOverviewSummaryQuery$variables,
} from './__generated__/SmartSpaceOverviewSummaryQuery.graphql.ts';

const SmartSpaceOverviewSummaryQuery = graphql`
	query SmartSpaceOverviewSummaryQuery($cloudId: ID!, $spaceKey: String!) {
		confluence_smartSpaceOverview(cloudId: $cloudId, spaceKey: $spaceKey) {
			summary {
				body
			}
		}
	}
`;

const styles = cssMap({
	summaryBody: {
		color: token('color.text'),
		font: token('font.body'),
		whiteSpace: 'pre-wrap',
	},
});

type SmartSpaceOverviewSummaryProps = {
	spaceKey: string;
};

export const SmartSpaceOverviewSummary = ({ spaceKey }: SmartSpaceOverviewSummaryProps) => {
	const { cloudId } = useSessionData();
	const { data } = useQueryInterop<
		SmartSpaceOverviewSummaryQuery$data,
		SmartSpaceOverviewSummaryQuery$variables
	>(SmartSpaceOverviewSummaryQuery, {
		variables: {
			cloudId,
			spaceKey,
		},
		skip: !cloudId,
	});

	const body = data?.confluence_smartSpaceOverview?.summary?.body;

	if (!body) {
		return null;
	}

	return (
		<div css={styles.summaryBody} data-testid="smart-space-overview-summary">
			{body}
		</div>
	);
};
